import React from 'react';
import {
  PhoneInput,
  PhoneInputProps,
  PhoneInputRefType,
} from 'react-international-phone';
import 'react-international-phone/style.css';
import { useThemeStore } from '../../state/theme';

type InputProps = PhoneInputProps & React.RefAttributes<PhoneInputRefType>;

const PhoneNumberInput: React.FC<InputProps> = ({ ...props }) => {
  const { isDarkMode } = useThemeStore();

  return (
    <PhoneInput
      {...props}
      inputClassName={`!w-full !rounded-md !rounded-l-none !px-3 !py-2 !shadow-sm !focus:outline-none ${
        isDarkMode
          ? '!bg-gray-700 !border-gray-600 !text-gray-100 !focus:border-indigo-500 !focus:ring-indigo-500'
          : '!border !border-gray-300 !focus:border-indigo-500 !focus:ring-indigo-500'
      } ${props.inputClassName}`}
      className={`${
        isDarkMode
          ? '[&_.react-international-phone-country-selector-button]:!bg-gray-700 [&_.react-international-phone-country-selector-button]:!border-gray-600 [&_.react-international-phone-country-selector-button]:!text-gray-100 [&_.react-international-phone-country-selector-button]:!rounded-r-none'
          : '[&_.react-international-phone-country-selector-button]:!rounded-r-none'
      } ${props.className}`}
      style={
        {
          ...(props.style || {}),
          '--react-international-phone-dropdown-background-color': isDarkMode
            ? '#374151'
            : 'white',
          '--react-international-phone-dropdown-text-color': isDarkMode
            ? '#F3F4F6'
            : 'black',
          '--react-international-phone-dropdown-item-background-color-hover':
            isDarkMode ? '#4B5563' : '#F3F4F6',
        } as React.CSSProperties
      }
    />
  );
};

export default PhoneNumberInput;
